import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    HStack,
    Stack,
    Button,
    Heading,
    Text,
    useColorModeValue,
    Textarea,
    Spinner,
    Select,
  } from '@chakra-ui/react';
  import { FormEvent, useCallback, useState } from 'react';

import { createShippRequest, createShippResponse, Shippment } from '../../../shared';
import { ApiError, callEndpoint } from '../fetch';
import { ENDPOINT_CONFIGS } from '../endpoints';
import { CheckCircleIcon, CloseIcon } from '@chakra-ui/icons';
import {  useNavigate } from 'react-router-dom';
import { ROUTES } from '../routes';
import { getLocalStorageADDRESS, getLocalStorageNAME, getLocalStoragePHONE, isCaptin, isLoggedIn } from '../fetch/auth';
import { RECEIVE_OPTIONS } from '../types';
  export default function CreateShippCard({editMode,shipp}:{editMode: boolean; shipp: Shippment | null}) {
    const navigate = useNavigate();
    const [shippId, setShippId] = useState(!shipp? "" : shipp.id);
    const [address, setAddress] = useState(!shipp? "" : shipp.addrees);
    const [desc, setDesc] = useState(!shipp? "" : shipp.description);
    const [conPhone, setConPhone] = useState(!shipp? "" : shipp.consMobile);
    const [conName, setConName] = useState(!shipp? "" : shipp.conName);
    const [senderAddr, setSenderAddr] = useState(!shipp? getLocalStorageNAME()+' - '+getLocalStorageADDRESS()+' - '+getLocalStoragePHONE() : shipp.senderAddress);
    const [charge, setCharge] = useState(!shipp? 0 : shipp.charge);
    const [notes, setNotes] = useState(!shipp? "" : shipp.notices);
    const [receiveState, setReceiveState] = useState(!shipp? 3 : shipp.receiveState);
    const [receiveDesc, setReceiveDesc] = useState(!shipp? '' : shipp.receiveDesc);
    const [error, setError] = useState('');
    const [resOk,setResOk]=useState(false);
    const [busy, setBusy] = useState(false);

    if(isCaptin()){
      navigate(ROUTES.HOME);
    }
     
      const handleSubmit = useCallback(
        async (e: FormEvent | MouseEvent) => {
          e.preventDefault();
    
          setBusy(true);
          if (!isLoggedIn()) {
            navigate(ROUTES.SIGN_IN);
          }
          setResOk(false);
          try {
        
           const res= await callEndpoint<createShippRequest, createShippResponse>((editMode ? ENDPOINT_CONFIGS.editShipp : ENDPOINT_CONFIGS.createShipp), {
              id:shippId,
              addrees:address,
              charge:charge,
              consMobile:conPhone,
              description:desc,
              notices:notes,
              senderAddress:senderAddr,
              receiveDesc:receiveDesc,
              receiveState:receiveState,
              conName:conName
            });
     
            if(!editMode){setShippId(res.shippId);}
            setResOk(true);
            setError('');
            setBusy(false);
           // navigate(ROUTES.HOME);
          } catch (e) {
         
            setError((e as ApiError).message);
            setBusy(false);
          }
        },
        [shippId, address, charge, conPhone, desc, notes, senderAddr, receiveState, receiveDesc, conName]
      );

    /*  function onChangeDate(date:string){
       let today=Number(new Date()) 
  
        if( today > new Date(date).getTime() ){
            setSuitDate(new Date(today));
            alert('تاريخ خاطئ');
            return
        }
        
        setSuitDate(new Date(date));
      }*/

      function onNewShipp(){

         setShippId("");
         setAddress("");
         setDesc("");
         setConPhone("");
         setSenderAddr("");
         setCharge(0);
         setNotes("");
         setError('');
         setResOk(false);
        
      }
    return (
      <form onSubmit={handleSubmit} dir='rtl'>
        <fieldset disabled={busy}>
      <Flex 
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}>
        <Stack spacing={5} w={'full'} mx={'auto'} maxW={'lg'} py={5} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'2xl'} textAlign={'center'}>
              {editMode? 'تعديل الطرد' : 'طرد جديد'}
            </Heading>           
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>

            {editMode &&           
              <FormControl id="id" isReadOnly>
              <FormLabel>كود الطرد</FormLabel>
              <Input type="text" value={shippId} />
              </FormControl>
            }
            <FormControl id="senderaddr" isRequired>
                <FormLabel>بيانات الراسل</FormLabel>
                <Input type="text"  value={senderAddr}  onChange={e => setSenderAddr(e.target.value)} />
              </FormControl>

              <FormControl id="conname" isRequired>
                <FormLabel>اسم المرسل إليه</FormLabel>
                <Input  value={conName} onChange={e => setConName(e.target.value)}/>
              </FormControl>

              <FormControl id="adress" isRequired>
                <FormLabel>عنوان المرسل إليه</FormLabel>
                <Input  value={address} onChange={e => setAddress(e.target.value)}/>
              </FormControl>
              
              <FormControl id="conphone" isRequired>
                <FormLabel>تليفون المرسل إليه</FormLabel>
                <Input type={'number'} value={conPhone} onChange={e => setConPhone(e.target.value)}/>
              </FormControl>

              <FormControl id="desc" isRequired>
                <FormLabel>محتوى الطرد</FormLabel>
                <Input type="text" value={desc} onChange={e => setDesc(e.target.value)}/>
              </FormControl>

              <FormControl id="charge" isRequired>
                <FormLabel>مبلغ التحصيل شامل الشحن</FormLabel>
                <Input type="number" value={charge} onChange={e => setCharge(Number(e.target.value))} onFocus={e => e.target.select()}/>
              </FormControl>

              <FormControl id="receivestate" >
                <FormLabel>استلام طرد من المرسل إليه</FormLabel>
                <Select dir={'ltr'} value={receiveState} onChange={e => setReceiveState(Number(e.target.value))} > 
       
                    {Object.keys(RECEIVE_OPTIONS).map((key,i)=>(
                      
                      <option key={i} value={i}>{RECEIVE_OPTIONS[key]}</option>
                      
                    ))}
  
                 </Select>   
               </FormControl>

              {receiveState!==3 &&
               <FormControl id="receivedesc" isRequired>
                <FormLabel>وصف الطرد المرتجع</FormLabel>
                <Input  value={receiveDesc} onChange={e => setReceiveDesc(e.target.value)}/>
              </FormControl>
              }

              <FormControl id="notes" >
                <FormLabel>ملاحظات</FormLabel>
                <Textarea value={notes} onChange={e => setNotes(e.target.value)}/>
              </FormControl>
 
              
            {!resOk &&
              <Stack spacing={10} pt={2}>
                <Button
                type='submit'               
                  loadingText="Submitting"
                  size="lg"
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}  >
                  {editMode? 'حفظ' : 'تسجيل الطرد'}
                </Button>
              </Stack>
              }

              {(resOk && editMode) && <>
              <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CheckCircleIcon boxSize={'20px'} color={'green.500'} />                           
                <Text color="green">تم تعديل الطرد بنجاح</Text>               
              </Stack> </>
              }

              {(resOk && !editMode) && <>
              <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CheckCircleIcon boxSize={'20px'} color={'green.500'} />                           
                <Text color="green"> تم تسجيل الطرد برقم {shippId}</Text>               
              </Stack>

              <HStack >
              <Button
             width={'full'}
              type='submit'               
                loadingText="New Shippment"
                size="lg"
                bg={'blue.400'}
                color={'white'}
                _hover={{
                  bg: 'blue.500',
                }} onClick={onNewShipp}>
                طرد جديد
              </Button>
              
              <Button
                width={'full'}
              type='submit'               
                loadingText="Home Page"
                size="lg"
                bg={'red.400'}
                color={'white'}
                _hover={{
                  bg: 'red.500',
                }} onClick={()=>{navigate(ROUTES.HOME);}}>
                الرئيسية
              </Button>
              </HStack>

              </>             
              }

              {!!error &&
               <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CloseIcon boxSize={'20px'} color={'white'} />
               <Text color="red.700">{error}</Text>             
               </Stack>
               }
            </Stack>
          {busy &&  
          <Stack pt={4}>
            <Spinner  alignSelf={'center'} />
            </Stack>
            }
          </Box>
          

          
        </Stack>
        
      </Flex>
      </fieldset>
      </form>
    );
  }


